import { Pagination } from 'types/indexTS';

interface MoreItemsParams<Model> {
  data: Array<Model> | null | undefined;
  query: {
    limit: number;
  };
  pagination?: Pagination;
}

export const canFetchMoreItems = <Model>({ data, query, pagination }: MoreItemsParams<Model>): boolean => {
  const fullLoadedItems = Array.isArray(data) && (data.length === 0 || data.length < (query.limit || 50));
  return Boolean(!fullLoadedItems && pagination && pagination.next);
};
